<div class="rechtstext">
  <h1>Datenschutzerklärung</h1>

  <h2>1. Verantwortlicher</h2>
  <p>
    IT-Service Karsten Fischer<br />
    Inhaber: Karsten Fischer<br />
    Martinshof 2, 88410 Bad Wurzach, Deutschland<br />
    Telefon: +49 (0)7568 30 90 137 · E-Mail:
    <a href="mailto:info@it-karsten-fischer.de">info@it-karsten-fischer.de</a><br />
    Wirtschafts-Identifikationsnummer gemäß § 139c AO: DE307304411-00001
  </p>

  <h2>2. Das Wichtigste vorab</h2>
  <p>
    Alle Kundendaten unserer Produkte KF Passwort-Safe und KF Akten-Safe (bis zum 1. September
    2026 unter der Marke „Vertraut" bzw. als „Dokumentensystem" angeboten) werden ausschließlich
    auf Servern in Deutschland gespeichert. Inhalte sind
    Zero-Knowledge-verschlüsselt: Auch wir selbst können Ihre Dokumente und Passwörter nicht
    einsehen. Zugriffe durch Ihren persönlichen Ansprechpartner sind nur möglich, wenn Sie sie ausdrücklich
    und zeitlich begrenzt freigeben; jeder Zugriff wird protokolliert und ist für Sie einsehbar.
  </p>

  <h2>3. Hosting dieser Website</h2>
  <p>
    Diese Website, das Kundenportal und die Safes laufen auf von uns selbst verwalteten Servern,
    die wir bei der ZAP-Hosting GmbH (Hafenweg 8, 48155 Münster) angemietet haben; Serverstandort
    ist Deutschland. Beim Aufruf werden technisch notwendige Daten verarbeitet (IP-Adresse, Datum
    und Uhrzeit, aufgerufene Seite, Browsertyp), Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO
    (sicherer und stabiler Betrieb). Die Zugriffsprotokolle des Webservers werden nach 14 Tagen
    gelöscht, Systemprotokolle der Server (etwa zu Anmeldeversuchen) spätestens nach 30 Tagen.
  </p>
  <p>
    Unsere Domains werden über die Namensauflösung (DNS) der Cloudflare, Inc. bereitgestellt. Der
    Datenverkehr dieser Website, des Kundenportals und der Safes läuft nicht über Cloudflare,
    sondern unmittelbar zu unseren Servern; Cloudflare erhält dabei keine Inhalte.
  </p>

  <h2>4. Kontaktaufnahme</h2>
  <p>
    Bei Kontakt per E-Mail oder Telefon verarbeiten wir die mitgeteilten Daten zur Bearbeitung der
    Anfrage (Art. 6 Abs. 1 lit. b bzw. f DSGVO). Die Daten werden gelöscht, sobald sie für die
    Bearbeitung nicht mehr erforderlich sind und keine gesetzlichen Aufbewahrungspflichten
    bestehen.
  </p>

  <h2>5. Registrierung und Nutzung des Kundenportals</h2>
  <p>
    Wenn Sie sich über diese Website registrieren oder eine Einladung des Anbieters annehmen,
    verarbeiten wir die von Ihnen angegebenen Daten (Name, E-Mail-Adresse, optional Telefonnummer)
    zur Einrichtung und Verwaltung Ihres Kundenportal-Zugangs.
  </p>
  <p>
    Im laufenden Betrieb des Kundenportals verarbeiten wir zudem Anmeldedaten (u. a. Sitzungs-Token
    zur Aufrechterhaltung Ihres Logins), den Inhalt von Ihnen erstellter Support-Anliegen (Tickets),
    vereinbarte Termine sowie den Bestand und Verlauf Ihres Einheitenkontos.
  </p>
  <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertrag oder vorvertragliche Maßnahmen)</p>

  <h2>6. Kundenkonto, Testphase und Zahlung (Stripe, PayPal)</h2>
  <p>
    Für die kostenlose 7-Tage-Testphase und den Abschluss eines Abonnements verarbeiten wir
    Bestandsdaten (Name, E-Mail-Adresse) und Vertragsdaten (gewähltes Paket, Laufzeit) auf
    Grundlage von Art. 6 Abs. 1 lit. b DSGVO. Die Testphase ist ohne Angabe von Zahlungsdaten
    möglich.
  </p>
  <p>
    Die Zahlungsabwicklung — auch für Einheitenpakete, den Passwort-Safe und das
    Akten-Safe — erfolgt über Stripe (Stripe Payments Europe Ltd., 1 Grand Canal
    Street Lower, Grand Canal Dock, Dublin, Irland). Stripe erhält die für die Zahlung
    erforderlichen Daten (Name, E-Mail, Rechnungsbetrag, Zahlungsinformationen); Rechtsgrundlage
    ist Art. 6 Abs. 1 lit. b DSGVO. Bei wiederkehrenden Zahlungen (Einheitenpakete, Passwort-Safe,
    Akten-Safe) speichert Stripe Zahlungsinformationen zur Durchführung der
    wiederkehrenden Abbuchungen.
  </p>
  <p>
    Stripe kann Daten in Drittländer (z. B. USA) übermitteln. Stripe ist nach dem EU-U.S. Data
    Privacy Framework zertifiziert. Details:
    <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer"
      >https://stripe.com/de/privacy</a
    >
  </p>

  <p>
    Einzelleistungen aus dem Support (z.&nbsp;B. eine Schritt-für-Schritt-Anleitung) bezahlen Sie
    vorab über PayPal (PayPal (Europe) S.à r.l. et Cie, S.C.A., 22-24 Boulevard Royal, 2449
    Luxemburg). Dafür werden Sie auf die Zahlungsseite von PayPal weitergeleitet; PayPal erhält
    Betrag, Bezeichnung der Leistung und unsere Vorgangsnummer, wir erhalten von PayPal die
    Bestätigung der Zahlung mit Ihrem Namen und Ihrer PayPal-E-Mail-Adresse. Rechtsgrundlage ist
    Art. 6 Abs. 1 lit. b DSGVO. PayPal ist für die Zahlungsabwicklung selbst Verantwortlicher und
    kann Daten in Drittländer übermitteln; Details:
    <a href="https://www.paypal.com/de/legalhub/privacy-full" target="_blank" rel="noopener noreferrer"
      >https://www.paypal.com/de/legalhub/privacy-full</a
    >
  </p>

  <h2>7. Zustimmung zum vorzeitigen Vertragsbeginn</h2>
  <p>
    Wenn Sie im Kundenportal eine kostenpflichtige Buchung bestätigen, deren Ausführung sofort mit
    Vertragsschluss beginnt (z. B. Erstbuchung, Upgrade, Jahrespaket oder Nachkauf eines
    Einheitenpakets sowie die Buchung des Passwort-Safe oder des Akten-Safe), holen
    wir hierfür Ihre ausdrückliche Zustimmung sowie Ihre Bestätigung der Kenntnis vom Verlust des
    Widerrufsrechts über ein gesondertes Kontrollkästchen ein (§ 356 Abs. 4 BGB, siehe AGB).
  </p>
  <p>
    Zu Nachweiszwecken protokollieren wir den Zeitpunkt dieser Zustimmung sowie die IP-Adresse, von
    der aus die Buchung ausgelöst wurde, in einem unveränderlichen (append-only) Protokoll.
  </p>
  <p>
    Rechtsgrundlage: Art. 6 Abs. 1 lit. c DSGVO i. V. m. § 356 Abs. 4 BGB (rechtliche
    Nachweispflicht), hilfsweise Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse am Nachweis
    einer wirksamen Zustimmung)
  </p>

  <h2>8. Nutzung der Produkte</h2>
  <p>
    <strong>Passwort-Safe und Akten-Safe:</strong> Inhalte (Passwörter, Dokumente) werden
    Ende-zu-Ende- bzw. Zero-Knowledge-verschlüsselt auf Servern in Deutschland gespeichert. Wir
    haben keinen inhaltlichen Zugriff. Metadaten (z. B. Speicherbelegung, Zeitpunkte von
    Zugriffen) verarbeiten wir zur Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO).
  </p>
  <p>
    <strong>Freigaben an Ihren Ansprechpartner:</strong> Geben Sie Ihrem persönlichen Ansprechpartner Unterlagen frei, erfolgt
    dies auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO); die Freigabe ist auf den
    von Ihnen gewählten Umfang und Zeitraum begrenzt (längstens ein Jahr), protokolliert und
    jederzeit widerrufbar.
  </p>
  <p>
    <strong>Ablage per WhatsApp:</strong> Wenn Sie uns Dokumente per WhatsApp senden, gelten
    zusätzlich die Datenschutzbestimmungen von WhatsApp (Meta Platforms Ireland Ltd.). Die
    Übermittlung erfolgt auf Ihre Initiative; das eingehende Dokument wird von unseren Mitarbeitern
    in Ihre verschlüsselte Ablage einsortiert und unmittelbar danach aus dem WhatsApp-Verlauf
    unserer Geräte gelöscht. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.
  </p>
  <p>
    <strong>KI-Funktionen im Akten-Safe (nur bei aktiver Nutzung):</strong> Drei Funktionen nutzen
    das KI-Modell Claude des Anbieters Anthropic: die automatische Einsortierung beim Ablegen (nur
    wenn Sie das Häkchen setzen, je Dokument einzeln), das Beantworten von Fragen an Ihre
    Unterlagen über das Frage-Feld sowie die KI-Unterstützung während einer von Ihnen erteilten
    Freigabe. Nur in diesen Momenten übermitteln wir die dafür nötigen, auf Ihrem Gerät
    entschlüsselten Textauszüge transportverschlüsselt an Anthropic; Grundlage der Übermittlung
    in die USA sind die EU-Standardvertragsklauseln (Art. 46 Abs. 2 lit. c DSGVO). Die Daten werden
    dort ausschließlich zur Beantwortung Ihrer Anfrage verarbeitet und nach den vertraglichen
    Vorgaben von Anthropic nicht zum Training der Modelle verwendet. Ohne Ihre aktive Nutzung
    dieser Funktionen verlässt kein Klartext Ihr Gerät; die Suchvektoren für die inhaltliche
    Suche berechnet ein lokaler Dienst auf unserem eigenen Server. Ihre Dokumente selbst bleiben
    dauerhaft in Deutschland gespeichert. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.
  </p>

  <h2>9. Passwort-Safe</h2>
  <p>
    Bei Buchung des Passwort-Safe stellen wir Ihnen einen persönlichen, verschlüsselten
    Online-Speicher für Zugangsdaten zur Verfügung. Die Ver- und Entschlüsselung erfolgt
    ausschließlich clientseitig auf Ihrem Gerät (Zero-Knowledge-Prinzip): Wir erhalten und speichern
    ausschließlich verschlüsselte Daten und haben keine Kenntnis von Ihrem Master-Passwort oder den
    unverschlüsselten Inhalten Ihres Passwort-Safes.
  </p>
  <p>
    Verarbeitet werden insoweit ausschließlich verschlüsselte Datensätze sowie Konto- und
    Nutzungsmetadaten (z. B. Zeitpunkt der letzten Anmeldung), nicht jedoch die eigentlichen, für
    uns nicht einsehbaren Inhalte.
  </p>
  <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</p>
  <p>
    Speicherdauer: Bis zur Beendigung des Vertrags über den Passwort-Safe; anschließend werden die
    verschlüsselten Daten nach 30 Tagen endgültig gelöscht, sofern keine gesetzliche
    Aufbewahrungspflicht entgegensteht. Aus den automatisierten Sicherungskopien (siehe Abschnitt
    „Akten-Safe") werden sie spätestens 90 Tage nach dieser Löschung vollständig entfernt.
  </p>

  <h2>10. Akten-Safe</h2>
  <p>
    Bei Buchung des Akten-Safe können Sie Dokumente in einem
    Ende-zu-Ende-verschlüsselten Online-Speicher ablegen. Die Verschlüsselung erfolgt vor dem
    Hochladen auf Ihrem Gerät (AES-256-GCM je Dokument, asymmetrische Schlüsselkapselung). Ihr
    privater Schlüssel wird ausschließlich in verschlüsselter Form (Argon2id) auf unseren Servern
    hinterlegt. Wir speichern ausschließlich verschlüsselte Dokumente und haben keine technische
    Möglichkeit, auf deren Inhalt zuzugreifen.
  </p>
  <p>
    Räumen Sie einem Mitarbeiter im Einzelfall — etwa im Rahmen eines Support-Falls oder über die
    Funktion „Blindablage" — einen zeitlich befristeten Zugriff auf Ihre Ablage ein, wird dieser
    Zugriff protokolliert. Sie bestimmen dabei den Umfang (gesamter Akten-Safe oder einzelne,
    von Ihnen ausgewählte Dokumente) und den letzten Geltungstag; die Freigabe endet zu dessen
    Tagesende, spätestens nach einem Jahr, und ist jederzeit vorzeitig widerrufbar. Ein
    dauerhafter oder anlassloser Zugriff findet nicht statt.
  </p>
  <p>
    Die verschlüsselte Ablage erfolgt auf zwei getrennten, ausschließlich für uns betriebenen
    Servern der ZAP-Hosting GmbH in Deutschland: einem Anwendungsserver und einem gesonderten,
    nicht öffentlich erreichbaren Datenserver, die ausschließlich über eine verschlüsselte
    Tunnelverbindung (WireGuard) miteinander kommunizieren. Automatisierte Sicherungskopien der
    verschlüsselten Daten werden alle 15 Minuten auf ein eigenes, getrenntes Sicherungssystem in
    unseren Geschäftsräumen in Deutschland übertragen und dort in Generationen (viertelstündlich,
    täglich, monatlich) für bis zu drei Monate vorgehalten; ein automatischer
    Wiederherstellungstest läuft wöchentlich.
  </p>
  <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</p>
  <p>
    Speicherdauer: Bis zur Beendigung des Vertrags über den Akten-Safe; anschließend
    werden die verschlüsselten Daten nach 30 Tagen endgültig gelöscht, sofern keine gesetzliche
    Aufbewahrungspflicht entgegensteht. Aus den Sicherungskopien werden sie spätestens 90 Tage
    nach dieser Löschung vollständig entfernt.
  </p>

  <h2>11. Notfallzugang / Vertrauensperson (Akten-Safe)</h2>
  <p>
    Wenn Sie im Akten-Safe eine Vertrauensperson für den Notfall benennen,
    verarbeiten wir hierzu Name und E-Mail-Adresse der benannten Person sowie die von Ihnen
    festgelegte Wartezeit. Führt die benannte Person noch kein eigenes Kundenkonto, richten wir für
    sie eines ein (siehe Abschnitt „Registrierung und Nutzung des Kundenportals"); führt sie
    bereits eines, wird dieses lediglich verknüpft, ohne dass ein zweites Konto entsteht.
  </p>
  <p>
    Fordert die Vertrauensperson den Notfallzugang an, protokollieren wir den Zeitpunkt dieser
    Anforderung sowie — im Fall eines Widerspruchs Ihrerseits oder einer automatischen
    Freischaltung nach Fristablauf — den jeweiligen Zeitpunkt und das Ergebnis in einem
    unveränderlichen (append-only) Protokoll, das sowohl Ihnen als auch der Vertrauensperson
    zugänglich ist.
  </p>
  <p>
    Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung – Ihnen gegenüber sowie, soweit
    die Vertrauensperson ein eigenes Kundenkonto führt, auch dieser gegenüber), im Übrigen Art. 6
    Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Umsetzung des von Ihnen eingerichteten
    Notfallmechanismus).
  </p>
  <p>
    Speicherdauer: Bis zum Widerruf der Benennung durch Sie bzw. bis zur Beendigung des Vertrags
    über den Akten-Safe.
  </p>

  <h2>12. Support- und Fernwartung</h2>
  <p>
    Im Rahmen von Supportleistungen (Telefon, Remote, Vor-Ort) können Geräteinformationen,
    Fehlerbeschreibungen, Kommunikationsinhalte sowie ggf. Zugriff auf Systeme im Rahmen einer
    Fernwartung verarbeitet werden.
  </p>
  <p>
    Für die Fernwartung setzen wir die freie Software RustDesk ein, die wir auf einem eigenen
    Server in Deutschland (remote.it-karsten-fischer.de, angemietet bei der ZAP-Hosting GmbH,
    siehe Abschnitt „Auftragsverarbeiter") selbst betreiben; ein Fernwartungsanbieter als Dritter
    ist nicht beteiligt. Eine Sitzung kommt nur zustande, wenn Sie uns die in Ihrem Programm
    angezeigte Kennung und das nur für diese Sitzung gültige Einmal-Passwort mitteilen; Sie sehen
    jederzeit mit, behalten Maus und Tastatur und beenden die Verbindung durch Schließen des
    Fensters. Die Bildschirminhalte sind zwischen Ihrem Gerät und unserem Bedienrechner
    Ende-zu-Ende verschlüsselt; unser Server vermittelt lediglich die Verbindung und verarbeitet
    dabei die Gerätekennung sowie die IP-Adressen der Beteiligten, jedoch keine Inhalte.
    Bildschirminhalte werden von uns weder aufgezeichnet noch gespeichert. Laden Sie das
    Programm für Mac, Linux oder Android nicht von unserer Website, sondern vom Hersteller bzw.
    aus einem App-Store, gelten für diesen Download zusätzlich dessen Datenschutzhinweise.
  </p>
  <p>
    Diese Bildschirmfreigabe erfolgt ausschließlich nach Ihrer ausdrücklichen Zustimmung, zeitlich
    begrenzt und zweckgebunden; nach dem Ende einer Sitzung ist ein erneuter Zugriff auf diesem Weg
    ohne Ihr Zutun technisch nicht möglich.
  </p>
  <p>
    Für Kunden mit laufender Betreuung bieten wir zusätzlich die <strong>KF Fernwartung</strong>
    an, einen dauerhaften Wartungszugang im Hintergrund, mit dem wir Prüfungen, Updates und
    Wartungsarbeiten durchführen können, ohne Sie bei der Arbeit zu stören. Die Einrichtung ist
    freiwillig und setzt Ihre Zustimmung zu den
    <a href="/fernwartung/bedingungen">Bedingungen und Datenschutzhinweisen der KF Fernwartung</a>
    voraus, die das Programm bei der Installation anzeigt. Ihr PC baut dabei selbst eine
    verschlüsselte Verbindung zu einem von uns betriebenen Server in Deutschland
    (remote.it-karsten-fischer.de, angemietet bei der ZAP-Hosting GmbH) auf; eine Verbindung von
    außen in Ihr Netzwerk wird nicht geöffnet, und ein Dritter ist nicht beteiligt. Ein Zugriff
    über diese Verbindung ist erst möglich, nachdem wir Ihren PC nach eigener Prüfung freigegeben
    haben, und erfolgt nur im Rahmen eines Auftrags oder einer Vereinbarung sowie nur so weit und
    so lange, wie es für die Wartung erforderlich ist. Das Programm zeigt den Zustand des Zugangs
    dauerhaft als Symbol im Infobereich an; jede Wartungssitzung wird protokolliert, und Sie
    können dieses Protokoll jederzeit direkt auf Ihrem PC einsehen. Sie können den Zugang
    jederzeit pausieren, beenden oder das Programm
    deinstallieren; danach lässt unser Server Ihr Gerät nicht mehr zu, und ein Zugang kann nur
    durch eine neue Einrichtung mit neuer Zustimmung entstehen. Bildschirminhalte werden auch bei
    der KF Fernwartung weder aufgezeichnet noch gespeichert.
  </p>
  <p>
    Im Rahmen der KF Fernwartung verarbeiten wir Ihre Kundennummer, die Bezeichnung und den
    Standort des PCs, eine Gerätekennung und den Geräteschlüssel, die IP-Adresse und die
    Verbindungszeiten des PCs, den Zeitpunkt und die Fassung Ihrer Zustimmung sowie die
    Protokolle der Wartungssitzungen. Das Sitzungsprotokoll enthält Zeitpunkt und Dauer der
    Sitzung, das betroffene Gerät (Zielsystem), die durchführende Person und die ausgeführten
    Wartungsbefehle; es enthält keine Bildschirmaufzeichnungen und keine Inhalte Ihrer Dateien
    oder Nachrichten. Zustimmungsnachweis und Sitzungsprotokolle bewahren wir zur Erfüllung
    unserer Nachweispflichten nach Art. 7 Abs. 1 und Art. 5 Abs. 2 DSGVO sowie zur
    Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen (Art. 17 Abs. 3 lit. e DSGVO)
    für die Dauer der regelmäßigen Verjährungsfrist (§§ 195, 199 BGB) auf, also drei Jahre ab dem
    Ende des Jahres, in dem der Zugang beendet wurde. Dieselben Festlegungen enthält der mit
    Ihnen geschlossene Vertrag zur Auftragsverarbeitung.
  </p>
  <p>
    Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Durchführung des Support- bzw.
    Betreuungsvertrags); für die Protokollierung der Wartungssitzungen und den
    Zustimmungsnachweis zusätzlich Art. 6 Abs. 1 lit. f DSGVO (Nachvollziehbarkeit und
    Sicherheit der Zugriffe).
  </p>

  <h2>13. Elektronische Unterschrift von Verträgen</h2>
  <p>
    Verträge, Auftragsbestätigungen und Vereinbarungen zur Auftragsverarbeitung können Sie bei
    uns elektronisch unterzeichnen. Dafür setzen wir die freie Software DocuSeal ein, die wir
    auf einem eigenen Server in Deutschland (sign.it-karsten-fischer.de, angemietet bei der
    ZAP-Hosting GmbH, siehe Abschnitt „Auftragsverarbeiter") selbst betreiben; ein
    Signaturdienst als Dritter ist nicht beteiligt.
  </p>
  <p>
    Sie erhalten dazu per E-Mail einen persönlichen Link. Beim Unterzeichnen verarbeiten wir
    Ihren Namen, Ihre E-Mail-Adresse, das zu unterzeichnende Dokument, Ihre Unterschrift (als
    Bild oder getippt), den Zeitpunkt, die IP-Adresse und die Browserkennung sowie ein
    Prüfprotokoll, das den Ablauf der Unterzeichnung dokumentiert und dem Nachweis des
    Vertragsschlusses dient. Nach Abschluss erhalten alle Beteiligten das unterzeichnete
    Dokument samt Prüfprotokoll per E-Mail (Versand über mailbox.org, siehe Abschnitt
    „Auftragsverarbeiter").
  </p>
  <p>
    Es handelt sich um eine einfache bzw. fortgeschrittene elektronische Signatur im Sinne der
    eIDAS-Verordnung, nicht um eine qualifizierte Signatur. Verlangt das Gesetz für eine
    Vereinbarung die Schriftform, weisen wir Sie gesondert darauf hin.
  </p>
  <p>
    Unterzeichnete Dokumente und Prüfprotokolle speichern wir für die Dauer des
    Vertragsverhältnisses und darüber hinaus, solange handels- und steuerrechtliche
    Aufbewahrungspflichten bestehen (in der Regel zehn Jahre). Nicht abgeschlossene Vorgänge
    löschen wir spätestens 90 Tage nach Versand des Links.
  </p>
  <p>
    Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung und -durchführung), Art. 6
    Abs. 1 lit. f DSGVO (Nachweis des Vertragsschlusses) sowie für die Aufbewahrung Art. 6
    Abs. 1 lit. c DSGVO.
  </p>

  <h2>14. Vertrags- und Kundendaten</h2>
  <p>
    Im Rahmen eines Vertrags über ein Einheitenpaket sowie über den Passwort-Safe oder
    den Akten-Safe verarbeiten wir insbesondere Name, Adresse, Kontaktdaten sowie
    Vertrags- und Abrechnungsdaten. Zweck der Verarbeitung ist die Vertragsdurchführung,
    Kundenbetreuung und Abrechnung.
  </p>
  <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO</p>

  <h2>15. Auftragsverarbeiter und Serverstandorte</h2>
  <p>
    Zur Erbringung unserer Leistungen setzen wir folgende Auftragsverarbeiter bzw. Dienstleister
    ein, mit denen jeweils ein Auftragsverarbeitungsvertrag nach Art. 28 DSGVO besteht oder — bei
    Übermittlung in Drittländer — geeignete Garantien vereinbart sind:
  </p>
  <ul>
    <li>
      Hosting (Website, Kundenportal, Passwort-Safe, Akten-Safe, Fernwartungs- und
      Benachrichtigungsserver): ZAP-Hosting GmbH, Hafenweg 8, 48155 Münster — von uns selbst
      verwaltete, angemietete Server, Serverstandort Deutschland.
    </li>
    <li>
      Datensicherung: eigenes Sicherungssystem in unseren Geschäftsräumen in Deutschland; kein
      Dritter beteiligt.
    </li>
    <li>
      E-Mail-Versand (u. a. Termin- und Einladungsmails): mailbox.org, betrieben von der
      Heinlein Hosting GmbH, Schwedter Straße 8/9A, 10119 Berlin. Die Server stehen
      ausschließlich in Deutschland; eine Übermittlung in Drittländer außerhalb der EU/des EWR
      findet nicht statt.
    </li>
    <li>
      Rechnungsstellung und Buchhaltung: Lexware Office, Haufe-Lexware GmbH &amp; Co. KG,
      Munzinger Straße 9, 79111 Freiburg. Dorthin übermitteln wir die für Rechnungen
      erforderlichen Daten (Name, Anschrift, Rechnungspositionen); Serverstandort Deutschland.
    </li>
    <li>
      KI-Funktionen des Akten-Safe: Anthropic (KI-Modell Claude), siehe Abschnitt
      „Nutzung der Produkte".
    </li>
    <li>Zahlungsabwicklung: Stripe und PayPal (siehe „Kundenkonto, Testphase und Zahlung" oben).</li>
    <li>
      Fernwartung: eigener RustDesk-Server auf unseren Servern in Deutschland (siehe Abschnitt
      „Support- und Fernwartung"); kein Dritter beteiligt.
    </li>
    <li>
      Elektronische Unterschrift: eigener DocuSeal-Server (sign.it-karsten-fischer.de) auf
      unseren Servern in Deutschland (siehe Abschnitt „Elektronische Unterschrift von
      Verträgen"); kein Signaturdienst als Dritter beteiligt.
    </li>
    <li>
      Interne Benachrichtigung unserer Mitarbeiter über neue Kundenanfragen, Nachrichten und
      Terminwünsche: eigener Benachrichtigungsserver (ntfy) auf unseren Servern in Deutschland.
      Damit die Mobilgeräte unserer Mitarbeiter geweckt werden, wird an die Push-Dienste von
      Apple bzw. Google sowie an den Dienst ntfy.sh lediglich eine inhaltslose Weckmeldung mit
      einer Nachrichtenkennung übermittelt; der Inhalt (etwa Ihr Name oder Ihr Terminwunsch)
      wird ausschließlich von unserem eigenen Server abgerufen und verlässt ihn nicht.
    </li>
  </ul>

  <h2>16. Weitergabe von Daten</h2>
  <p>
    Eine Weitergabe personenbezogener Daten erfolgt nur, wenn dies zur Vertragserfüllung
    erforderlich ist, wenn eine gesetzliche Verpflichtung besteht, oder wenn eine ausdrückliche
    Einwilligung vorliegt. Eine Übermittlung zu Werbezwecken erfolgt nicht.
  </p>

  <h2>17. Technische und organisatorische Maßnahmen</h2>
  <p>
    Für den Passwort-Safe und den Akten-Safe setzen wir eine clientseitige
    Ende-zu-Ende-Verschlüsselung ein, sodass wir selbst keinen Zugriff auf die unverschlüsselten
    Inhalte haben (siehe die jeweiligen Abschnitte oben).
  </p>
  <p>
    Der interne Zugriff unserer Mitarbeiter auf Kunden- und Vertragsdaten im Verwaltungssystem ist
    rollenbasiert gestaffelt und nur nach dem Need-to-know-Prinzip möglich. Mitarbeiterkonten
    werden ausschließlich per Einladung eingerichtet und sind zwingend mit einer
    Zwei-Faktor-Authentifizierung gesichert.
  </p>
  <p>
    Zugriffe im Rahmen der Blindablage-Funktion des Akten-Safe werden
    protokolliert und sind zeitlich sowie inhaltlich begrenzt.
  </p>
  <p>
    Unsere Server sind durch Firewalls, Brute-Force-Schutz, automatische Sicherheitsupdates und
    einen ausschließlich schlüsselbasierten Verwaltungszugang (keine Passwort-Anmeldung)
    gesichert. Der Datenserver des Akten-Safe ist nicht öffentlich erreichbar. Sicherungskopien
    werden automatisch erstellt und wöchentlich auf Wiederherstellbarkeit geprüft.
  </p>

  <h2>18. Speicherdauer</h2>
  <p>
    Personenbezogene Daten werden nur so lange gespeichert, wie dies für die Vertragsdurchführung
    erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen (z. B. handels- und
    steuerrechtliche Pflichten). Für den Passwort-Safe und den Akten-Safe gelten
    die oben genannten Löschfristen nach Vertragsende.
  </p>

  <h2>19. Ihre Rechte</h2>
  <p>
    Sie haben das Recht auf Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17),
    Einschränkung (Art. 18), Datenübertragbarkeit (Art. 20) und Widerspruch (Art. 21 DSGVO) sowie
    das Recht, eine erteilte Einwilligung jederzeit zu widerrufen. Beschwerden richten Sie an eine
    Datenschutz-Aufsichtsbehörde, z. B. den Landesbeauftragten für den Datenschutz und die
    Informationsfreiheit Baden-Württemberg, Lautenschlagerstraße 20, 70173 Stuttgart (<a
      href="https://www.baden-wuerttemberg.datenschutz.de"
      target="_blank"
      rel="noopener noreferrer">www.baden-wuerttemberg.datenschutz.de</a
    >).
  </p>

  <h2>20. Stand</h2>
  <p>
    Diese Datenschutzerklärung hat den Stand 15.10.2026 (zuvor 04.10.2026, 25.09.2026, 18.09.2026
    und 05.09.2026; neu: Bezahlung von Einzelleistungen über PayPal im Abschnitt „Kundenkonto,
    Testphase und Zahlung"). Wir passen sie an, wenn sich Technik oder
    Rechtslage ändern.
  </p>
</div>
